/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class ItemPriceField extends PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field required>
        <label>Price</label>
        <Input
          label={{ content: '$' }}
          labelPosition="right"
          placeholder="e.g $ 3.50"
          type="number"
          min="0"
          step="0.01"
          required
          onChange={e => onChange('current_price', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/priceField.js